import React, { useEffect, useState } from 'react'
import { HTTP } from '../../../api/resources'

export default function PaymentMethodModal({invoice, close}) {
    const [paymentMethod, setPaymentMethod] = useState(invoice.payment_method)
    const [loading, setLoading] = useState(false)

    const proceed = async () => {
        setLoading(true)
        try {
            const response = await paymentMethodRequest()
            if (response && response.data && response.data.checkout_url) {
                window.location.href = response.data.checkout_url
            }
        } catch (error) {
            console.error('Error changing payment method:', error)
            Alert.show('error', error.response?.data?.message || 'An error occurred while changing the payment method.')
            setLoading(false)
        }
    }

    const paymentMethodRequest = () => {
        return HTTP.post(`/invoice/change_payment_method/${invoice.user_id}/${invoice.id}`)
    }

    const capitalize= (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <div className='form-group'>
                    <h4>Payment Method</h4>
                    {!paymentMethod && <small>No Payment Method Added</small>}

                    {paymentMethod && paymentMethod.last4 && (
                        <div className="list-group list-group-flush">
                            <div className="list-group-item">
                            <div className="list-group-item-body">
                                <div className="list-group-item-body-main-invoices">
                                <div className="list-item-title-segment" style={{textAlign: 'left'}}>
                                    <p><span style={{fontWeight: 'bold'}}>Brand: </span> <i>{`${capitalize(paymentMethod.brand)}`}</i></p>
                                    <p><span style={{fontWeight: 'bold'}}>Last 4: </span> <i>{`•••• ${paymentMethod.last4}`}</i></p>
                                    <p><span style={{fontWeight: 'bold'}}>Exp: </span> <i>{`${String(paymentMethod.exp_month).padStart(2, '0')}/${paymentMethod.exp_year}`}</i></p>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    )} 

                    {paymentMethod && !paymentMethod.last4 && (
                        <div>
                            <small>Click proceed to continue to change your payment method for this invoice</small>
                        </div>
                    )}
                </div>

                <div className="pt-3">
                    <button onClick={proceed} type="button" className="btn btn-primary mr-2" disabled={loading}>
                        {loading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                        Proceed
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2" disabled={loading}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
